var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#220C4A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4466 12.9709C7.88913 12.7006 5.89794 10.5782 5.89794 8C5.89794 5.23858 8.18221 3 11 3C13.5937 3 15.7354 4.89672 16.0596 7.35205L17.7387 5.67296C16.76 2.95089 14.1125 1 11 1C7.05509 1 3.85712 4.13401 3.85712 8C3.85712 10.4125 5.10243 12.5399 6.99745 13.7986C3.95595 15.0709 1.67337 17.7491 1 21H3.09388C3.72626 18.5922 5.47376 16.6231 7.76468 15.6529L10.4466 12.9709ZM17.7071 18.4384C18.2512 19.2053 18.6618 20.0699 18.9061 21H21C20.693 19.5178 20.0515 18.1546 19.156 16.9895L17.7071 18.4384ZM17.7857 15.5314L16.3552 16.9618C15.8389 16.5217 15.2656 16.1441 14.6476 15.8411L16.1331 14.3555C16.7244 14.6934 17.2778 15.0879 17.7857 15.5314ZM17.5783 10.7323L16.546 9.70001L11.2425 15.0035C12.0813 15.0274 12.8883 15.1754 13.6451 15.4293L15.1936 13.8808C15.1303 13.8528 15.0666 13.8254 15.0025 13.7986C16.1361 13.0457 17.0372 11.982 17.5783 10.7323ZM18.1422 8.09789C18.1313 8.87846 17.99 9.62817 17.7387 10.327L16.8259 9.41421L18.1422 8.09789Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7756 11.5355L18.2401 8L16.8259 9.41421L20.3614 12.9497L21.7756 11.5355ZM16.546 12.5284L17.2531 13.2355L11.4749 19.0137H10.7678V18.3066L16.546 12.5284ZM8.76782 21.0137H12.3034L20.0815 13.2355L16.546 9.70001L8.76782 17.4782V21.0137Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUser);
export default __webpack_public_path__ + "static/media/edit-user.913466189469229e32394014c1502877.svg";
export { ForwardRef as ReactComponent };